import { NativeModulesProxy } from 'expo-modules-core';

import { BackgroundNotificationTasksModule } from './BackgroundNotificationTasksModule.types';

export default NativeModulesProxy.ExpoBackgroundNotificationTasksModule as BackgroundNotificationTasksModule;
